import { createFileRoute } from '@tanstack/react-router';
import LoadingPage from '../../../../../components/shared/page-components/LoadingPage';
import ExchangePage from '../../../../../components/source-management/exchanges/exchange-page/ExchangePage';

export const Route = createFileRoute(
  '/_authenticated/(sources)/exchanges/$exchangeId/_exchange',
)({
  pendingComponent: () => <LoadingPage loadingPage />,
  component: ExchangePage,
  staticData: {
    meta: {
      title: 'Exchange Details | Ledgible',
    },
  },
});
